// extracted by mini-css-extract-plugin
module.exports = {"startupGaining":"StartupGaining_startupGaining__1uvb5","cards":"StartupGaining_cards__2a888","card":"StartupGaining_card__2yf-l","btn":"StartupGaining_btn__hvu2y"};